/* eslint-disable unused-imports/no-unused-vars */
import size from 'lodash/size';
import { createSelector } from 'reselect';
import { staticCategories } from '../services/reducers/categoriesReducer';
import type { Category } from '../sharedTypes';
import { CATEGORY_ID } from '../utils/categories';

export function findPathToCategory(
  categories: Category[],
  targetId: string | null,
  path: Array<[string | null, string]> = [],
): Array<[string | null, string]> {
  if (!categories.length) return path;
  for (const category of categories) {
    path.push([category.id, category.name]);
    const categoryId = category.id && category.id.toString();
    if (categoryId === targetId) return path;
    findPathToCategory(category.children, targetId, path);
    const lastCategoryId = path[path.length - 1][0];
    if ((lastCategoryId && lastCategoryId.toString()) === targetId) return path;
    path.pop();
  }
  return path;
}

export const selectSponsoredProductsCategory = createSelector(
  (state, props) => state.productsState.sponsoredProductIds,
  (sponsoredProductIds) => {
    const sponsoredProductsCategory = size(sponsoredProductIds)
      ? [
          {
            id: CATEGORY_ID.sponsored,
            name: 'Free Gift!',
            children: [],
          },
        ]
      : [];
    return sponsoredProductsCategory;
  },
);

export const selectPathToSelectedCategory = createSelector(
  (state, props) => state.categoriesState.categories,
  (state, props) => selectSponsoredProductsCategory(state),
  (state, props) => props.selectedCategoryId,
  (categories, sponsoredProductsCategory, selectedCategoryId) =>
    findPathToCategory(
      [...categories, ...sponsoredProductsCategory, ...staticCategories],
      selectedCategoryId,
    ).map((categoryIdAndName) => categoryIdAndName[1]),
);
